<div class="panel_wrapper assign_venues">
  <p-progressSpinner class="w-100 text-center" *ngIf="spinner"></p-progressSpinner>
  <div class="venue_checkboxes">
    <div *ngFor="let venue of listAllVenues" class="field-checkbox d-flex flex-row mb-4">
      <p-checkbox name="venues_group" [value]="venue.id" [(ngModel)]="selectedVenues" [inputId]="venue.id.toString()"></p-checkbox>
      <label [for]="venue.id" class="venue_checkbox_label ms-3">{{venue.name}}</label>
    </div>
  </div>
  <button class="btn_login w-100 mt-0" (click)="assignVenues(menuId, selectedVenues)">{{ 'SAVE' |translate}}</button>
</div>
